import firebase from "firebase";
const firebaseConfig = {
  apiKey: "AIzaSyAUecxb_As2f4_yIzJacNQbFMF0sQoCIHU",
  authDomain: "whatsapp-clone-87196.firebaseapp.com",
  databaseURL: "https://whatsapp-clone-87196.firebaseio.com",
  projectId: "whatsapp-clone-87196",
  storageBucket: "whatsapp-clone-87196.appspot.com",
  messagingSenderId: "258798886259",
  appId: "1:258798886259:web:5bd2465614ba620eccf906",
  measurementId: "G-Z9NG4EJ5CY",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
